import React, { useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import { Pagination, Stack } from '@mui/material';
import useProductListing from '../hooks/useProductListing';

/* NOTE ON WHAT THIS PAGE ACTUALLY SHOWS.
 *
 * Despite the heading, it is the whole catalogue in default order — it is not
 * sorted by sales or rating. The previous version computed:
 *
 *     const highRatedProducts = products.filter(p => p.rating >= 4.5);
 *
 * which was doubly inert: `rating` is not a field on a WooCommerce product (it
 * is `average_rating`), and the result was never rendered — the grid mapped over
 * `products`. Both lines are gone rather than left to imply a filter exists.
 *
 * Making the page mean its name is one argument away: pass
 * `orderby: 'popularity'` to the hook below (the Store API supports it, and the
 * hook already forwards it). That changes what customers see, so it is a
 * merchandising decision rather than something to slip into a performance fix.
 */

function BestSelling({ isAuthenticated, onAddToCart }) {
  const navigate = useNavigate();

  const {
    products,
    loading,
    error,
    currentPage,
    totalPages,
    setPage,
  } = useProductListing({ perPage: 30 });

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user_data')) || {};
    if (userData.isSuperAdmin) navigate('/dashboard');
  }, [navigate]);

  if (loading) return <Loader />;

  return (
    <div className="content-wrapper">
      <section className="best-selling">
        <h3 style={{ fontSize: '22px', textAlign: 'center', margin: '20px 0' }}>
          {'best selling products'.toLocaleUpperCase()}
        </h3>
        <section className="char-products-section" style={{ margin: '0 0 20px' }}>
          <div className="small-container d-grid">
            {products.length > 0 ? (
              products.map(item => (
                <ProductCard
                  isAuthenticated={isAuthenticated}
                  onAddToCart={onAddToCart}
                  key={item.id}
                  product={item}
                />
              ))
            ) : (
              <p>{error || 'No products found!'}</p>
            )}
          </div>
          {totalPages > 1 && (
            <Stack spacing={2} style={{ margin: '5% auto 0', display: 'flex', alignItems: 'center' }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, value) => setPage(value)}
                color="primary"
              />
            </Stack>
          )}
        </section>
      </section>
    </div>
  );
}

export default BestSelling;
